// extracted by mini-css-extract-plugin
export default {"container":"Main_container__Hq88k","boxes":"Main_boxes__fX8Th"};